import { Link } from 'react-router-dom';
import type { TrialStatus } from '../services/api-client';

interface TrialIndicatorProps {
  status: TrialStatus | null;
}

export default function TrialIndicator({ status }: TrialIndicatorProps) {
  // D138: silent unless trial ends today or tomorrow (daysRemaining <= 1)
  if (!status || !status.active || status.daysRemaining === null || status.daysRemaining > 1) {
    return null;
  }

  const label = status.daysRemaining <= 0 ? 'Trial ends today' : 'Trial ends tomorrow';

  return (
    <Link
      to="/subscription"
      className="font-emphasis text-xs font-semibold uppercase tracking-wide text-warning border border-warning rounded px-2 py-1 hover:bg-warning hover:text-warning-foreground transition-colors"
    >
      {label}
    </Link>
  );
}
